const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const DISCOUNT_2 = 1400;
const DISCOUNT_3 = 2800;
const DISCOUNT_4 = 5800;
const PRODUCT_WINES_TITLES = ["French Red", "French Rosé", "Italian White", "Italian Red (Limited Release)"];
const MAX_WINES_LIMIT = 4;

document.addEventListener("DOMContentLoaded", async function () {
  const pickers = document.querySelectorAll(".picker");
  const quantityBtns = document.querySelectorAll("[btn-quantity]");
  const purchaseOptions = document.querySelectorAll(".purchase-option");
  const btnPurchase = document.querySelector(".btn-purchase button");
  const benefitsContainer = document.querySelector('.benefits-container');
  const benefitsParent = benefitsContainer?.parentElement;
  const productsImage = document.querySelector('.products-image');

  moveBenefitsList();

  window.addEventListener('resize', function () {
    moveBenefitsList();
  });

  function moveBenefitsList() {
    if (window.innerWidth > 1192) {

      if (benefitsContainer && productsImage) {

        productsImage.appendChild(benefitsContainer);
      }
    } else {
      if (benefitsContainer && benefitsParent) {
        console.log('moving benefits');
        benefitsParent.appendChild(benefitsContainer);
      }
    }
  }


  setTimeout(() => {
    if (!outOfStock) {
      document.querySelector('[data-input-quantity]')
        .value = 1;
      document.querySelector('[data-input-quantity]')
        .dispatchEvent(new Event('change'))
    }

  }, 0);


  if (outOfStock) {
    document.querySelectorAll('.purchase-option input').forEach(function (el) {
      el.setAttribute('disabled', 'disabled');
    })
    const frequencySelector = document.querySelector('.frequency-selector select');
    frequencySelector.setAttribute('disabled', 'disabled');
    frequencySelector.style.background = '#f1f1f1';
    const picker = document.querySelector('#quantity-picker');
    picker.style['border-color'] = '#616161';
    picker.style.opacity = '0.5';
    picker.querySelectorAll('input, button').forEach(function (el) {
      el.value = 0;
      el.setAttribute('disabled', 'disabled');
    });
  }

  purchaseOptions.forEach((option) => {
    const input = option.querySelector("input");
    if (!input) return;
    input.addEventListener("change", function () {
      const purchaseType = getPurchaseTypeSelected();
      const text = purchaseType === "one-time" ? "Add to Cart" : "Subscribe";
      btnPurchase.querySelector("span.text").textContent = text;
    });
  });



  quantityBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const input = btn.parentElement.querySelector("[data-input-quantity]");
      const value = parseInt(input.value);

      if (btn.dataset.type === "minus") {
        if (value > 0) {
          input.value = value - 1;
        }
      } else {
        input.value = value + 1;
      }

      input.dispatchEvent(new Event("change"));
    });
  });

  btnPurchase.addEventListener("click", async function () {
    const products = getProductsSelected();

    if (!products.length) return;

    const purchaseType = getPurchaseTypeSelected();

    btnPurchase.classList.add("loading");

    const currentCartItems = await getCurrentCartItems();

    let items = [];
    let bundleItems = null;

    if (purchaseType === "one-time") {
      items = products.map((product) => {
        return {
          quantity: product.quantity,
          id: product.variantId,
        };
      });
    } else {
      const sellingPlanId = getSellingPlanId();
      const bundleProductData = {
        variantId: `${productBundleVariantId}`,
        productId: `${productBundleId}`,
        sellingPlan: Number(sellingPlanId),
        handle: "medly-wine",
      };

      const bundle = {
        externalVariantId: bundleProductData.variantId,
        externalProductId: bundleProductData.productId,
        selections: products.map((product) => {
          return {
            collectionId: "279920443452",
            sellingPlan: sellingPlanId,
            externalProductId: `${product.productId}`,
            externalVariantId: `${product.variantId}`,
            quantity: product.quantity,
          };
        }),
      };

      bundleItems = await recharge.bundle.getDynamicBundleItems(
        bundle,
        bundleProductData.handle
      );

      items = products.map((product) => {
        return {
          selling_plan: sellingPlanId,
          quantity: product.quantity,
          id: product.variantId,
        };
      });
    }

    await addItemsCart(bundleItems ?? items);
    await updateMiniCart();
    updateCartCount();

    btnPurchase.classList.remove("loading");
  });

  pickers.forEach((picker) => {
    const input = picker.querySelector("[data-input-quantity]");
    input.addEventListener("change", function () {
      if (this.value < 0) {
        this.value = 0;
      }

      if (isNaN(this.value)) {
        this.value = 0;
      }

      if (!this.value) {
        this.value = 0;
      }

      const totalItens = getTotalPouches();
      const quantityPouches = document.getElementById("quantity-pouches");

      if (totalItens) {
        quantityPouches.classList.add("active");
      } else {
        quantityPouches.classList.remove("active");
      }

      document.querySelector("[total-pouch]").textContent = totalItens;
      document.querySelector("[multiplier-pouch]").textContent = totalItens * 4;
      const nextDiscount = getNextDiscountPercent();

      const totalValue = getTotal();
      const subTotalValue = getSubTotal();

      console.log('=== DEBUG CALCULATION ===');
      console.log('Quantity:', this.value);
      console.log('Raw SubTotal oneTimePurchase (cents):', subTotalValue.oneTimePurchase);
      console.log('Raw SubTotal subscribe (cents):', subTotalValue.subscribe);
      console.log('Raw Total oneTimePurchase (cents):', totalValue.oneTimePurchase);
      console.log('Raw Total subscribe (cents):', totalValue.subscribe);
      console.log('Formatted subtotal one-time:', formatter.format(subTotalValue.oneTimePurchase / 100));
      console.log('Formatted total one-time:', formatter.format(totalValue.oneTimePurchase / 100));
      console.log('========================');

      document.querySelector("[data-total-one-time]").textContent =
        formatter.format(totalValue.oneTimePurchase / 100);

      if (!forceSubscriptionOnly && !forceOneTimeOnly && this.value < 2) {
        document.querySelector(".purchase-option.subscribe").classList.add("d-none");
        document.querySelector('input[data-purchase-type="one-time"]').click();
        document.querySelector("[data-subtotal-subscription]").classList.add("hide");
        document.querySelector("[data-subtotal-one-time]").classList.add("hide");
      }

      if (!forceSubscriptionOnly && !forceOneTimeOnly && this.value >= 2) {
        document.querySelector(".purchase-option.subscribe").classList.remove("d-none");

          if (totalValue.oneTimePurchase < subTotalValue.oneTimePurchase) {
            document.querySelector("[data-subtotal-one-time]").classList.remove("hide");
          } else {
            document.querySelector("[data-subtotal-one-time]").classList.add("hide");
          }

          if (totalValue.subscribe < subTotalValue.subscribe) {
            document.querySelector("[data-subtotal-subscription]").classList.remove("hide");
          } else {
            document.querySelector("[data-subtotal-subscription]").classList.add("hide");
          }

        if (this.value == 2) {
          document.querySelector('[data-purchase-type="subscribe"').click();
        }
      }

      document.querySelector("[data-total-subscription]").textContent =
        formatter.format(totalValue.subscribe / 100);
      document.querySelector("[data-subtotal-one-time]").textContent =
        formatter.format(subTotalValue.oneTimePurchase / 100);
      document.querySelector("[data-subtotal-subscription]").textContent =
        formatter.format(subTotalValue.subscribe / 100);
    });
  });

  async function addItemsCart(items) {
    const body = JSON.stringify({ items });
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
  }

  async function changeCartItem(item) {
    const body = JSON.stringify(item);
    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
  }

  async function getCurrentCartItems() {
    const currentCartItems = [];
    const cartRes = await fetch("/cart.js");
    if (!cartRes.ok) {
      return [];
    }

    const cart = await cartRes.json();
    const items = cart.items;

    for (const item of items) {
      currentCartItems.push({
        variantId: item.variant_id,
        quantity: item.quantity,
        lineItemKey: item.key,
        maximumQuantityReachedOut: item.quantity >= MAX_WINES_LIMIT,
        isSubscription: item.selling_plan_allocation !== undefined,
        isWine: PRODUCT_WINES_TITLES.includes(item.product_title),
      });
    }

    return {
      items: currentCartItems,
      totalWinesQuantity: currentCartItems
        .map((i) => i.quantity)
        .reduce((a, b) => a + b, 0),
    };
  }

  async function updateMiniCart() {
    const cartDrawerBody = document.querySelector('[data-section="ajax-cart"]');
    await fetch("/?sections=ajax-cart")
      .then((res) => res.json())
      .then((res) => {
        cartDrawerBody.innerHTML = res["ajax-cart"];
      })
      .then(() => {
        let cartItemRemoveElements = document.querySelectorAll("[data-cart-item-remove]");
        Array.from(cartItemRemoveElements).forEach(function (element) {
          initCartItemRemove(element);
        });
        return openDrawerCart();
      });
  }

  function openDrawerCart() {
    document.querySelector("[data-side-drawer-open]").click();
  }

  function getProductsSelected() {
    const pickers = document.querySelectorAll(".picker");
    const items = [];
    pickers.forEach((picker) => {
      const input = picker.querySelector("[data-input-quantity]");
      const sellingPlanIds = [];
      const quantity = parseInt(input.value);
      picker
        .querySelectorAll("[data-selling-plan-id]")
        .forEach((el) => sellingPlanIds.push(Number(el.value)));
      if (quantity > 0) {
        items.push({
          productId: Number(picker.dataset.productId),
          variantId: Number(picker.dataset.productVariantId),
          sellingPlanIds,
          quantity,
        });
      }
    });

    return items;
  }

  function getSubscriptionFrequencySelected() {
    const frequencySelector = document.querySelector(".frequency-selector select");
    return frequencySelector.value;
  }

  function getPurchaseTypeSelected() {
    const purchaseOptions = document.querySelector(".purchase-option input:checked");
    return purchaseOptions.dataset.purchaseType;
  }

  function getTotalPouches() {
    const pickers = document.querySelectorAll(".picker");
    let total = 0;
    pickers.forEach((picker) => {
      const input = picker.querySelector("[data-input-quantity]");
      total += parseInt(input.value);
    });
    return total;
  }

  function getNextDiscountPercent() {
    const totalPouches = getTotalPouches();
    const nextDiscount = calculateDiscount(totalPouches + 1);

    const nextSubTotal =
      getSubTotal().oneTimePurchase +
      parseFloat(document.querySelector("[data-product-price]").dataset.productPrice);
    const nextSubTotalWithDiscount = nextSubTotal - nextDiscount;

    const nextDiscountPercent = (
      ((nextSubTotal - nextSubTotalWithDiscount) / nextSubTotal) * 100
    ).toFixed(2);

    return nextDiscountPercent;
  }

  // ✅ ALTERAÇÃO 2: Buscar preço no próprio picker
  function getSubTotal() {
    const pickers = document.querySelectorAll(".picker");
    let total = 0;
    
    pickers.forEach((picker) => {
      const input = picker.querySelector("[data-input-quantity]");
      const quantity = parseInt(input.value);
      const price = parseFloat(picker.dataset.productPrice);
      
      console.log('🔍 Picker debug:', {
        quantity,
        price,
        subtotal: quantity * price
      });
      
      total += quantity * price;
    });

    console.log('🔍 Total calculated in getSubTotal:', total);

    return {
      oneTimePurchase: total,
      subscribe: total
    };
  }

  function getTotal() {
    const totalQuantity = getTotalPouches();
    const totalDiscount = calculateDiscount(totalQuantity);
    const totalOneTimePurchase = getSubTotal().oneTimePurchase;
    const totalDiscountSubscribe = calculateDiscountSubscribe(totalQuantity);
    
    return {
      oneTimePurchase: totalOneTimePurchase - totalDiscount,
      subscribe: totalOneTimePurchase - totalDiscountSubscribe,
    };
  }

  function getSellingPlanId() {
    const quantity = document.getElementById('frequency-picker').value;
    const sellingPlanId = document.querySelector(
      `[data-selling-plan-frequency-id="${quantity}"]` 
    );
    return sellingPlanId.value;
    //
    const frequencySelector = document.querySelector(
      ".frequency-selector select"
    );
    return frequencySelector.value;
  }

  function calculateDiscount(totalPonchesDef) {
    if (noPouchDiscount) return 0;

    const totalPouches = totalPonchesDef ?? getTotalPouches();

    // A partir de 4 pouches, cada pouch recebe o mesmo desconto do pack de 4
    if (totalPouches >= 4) {
      return (DISCOUNT_4 / 4) * totalPouches;
    }

    let rest = totalPouches;
    let discount = 0;

    while (rest >= 2) {
      if (rest >= 4) {
        discount += DISCOUNT_4;
        rest -= 4;
        continue;
      }

      if (rest >= 3) {
        discount += DISCOUNT_3;
        rest -= 3;
        continue;
      }

      if (rest >= 2) {
        discount += DISCOUNT_2;
        rest -= 2;
        continue;
      }
    }

    return discount;
  }

  function calculateDiscountSubscribe(quantity) {
    if (noPouchDiscount) return 0;

    switch (quantity) {
      case 1:
        return 0;
      case 2:
        return 1800;
      case 3:
        return 3800;
      default:
        // A partir de 4 pouches, cada pouch recebe o mesmo desconto do pack de 4
        return quantity >= 4 ? (7800 / 4) * quantity : 0;
    }
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((data) => {
        const quantity = data.items.reduce((prev, curr) => prev + curr.quantity, 0);
        cartCountUpdate(quantity);
      });
  }
});